import { Component, OnDestroy, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { Subscription } from "rxjs";
import { LoginService } from "src/app/services/login.service";

@Component({
    selector: 'login',
    templateUrl: './login.page.html',
    standalone: false
})
export class LoginPage implements OnInit, OnDestroy {

  private subscription$: Subscription = new Subscription;
  private returnUrl: string = '';

  constructor(
    activatedRoute: ActivatedRoute,
    private router: Router,
    private loginService: LoginService
  ) {
    activatedRoute.queryParams.subscribe(queryParams => this.onQueryStringLoaded(queryParams['accessToken'], queryParams['returnUrl']));
  }

  ngOnInit(): void {
    this.subscription$.add(this.loginService.getLoginSuccess().subscribe(authenticated => {
      if (authenticated === true && this.returnUrl) {
        this.router.navigate([`${this.returnUrl}`]);
      } else if (authenticated === false) {
        this.router.navigate([`invalid`]);
      }
    }));
  }

  ngOnDestroy(): void {
    this.subscription$.unsubscribe();
  }

  onQueryStringLoaded(accessToken: string, returnUrl: string) {
    // TECHNICAL DEBT
    // We've had to move this call to app.component.ts to enable auto-login.
    // When we add a proper login screen in future we can look at refactoring
    // this call back into login.page.ts.

    //this.loginService.login(accessToken);
    this.returnUrl = returnUrl;
  }
}
